import SimpleLightbox from "simplelightbox";
import "simplelightbox/dist/simple-lightbox.min.css";

let lightbox = new SimpleLightbox('.gallery a', {
    captionsData: 'alt',
    captionDelay: 250,
  });

export function createGallery(images) {
    const gallery = document.querySelector('.gallery');
    const markup = images.map((image) => {
        return `<li class="gallery-item">
        <a class="gallery-link" href="${image.largeImageURL}">
            <img class="gallery-image" 
            src="${image.webformatURL}" 
            alt="${image.tags}"/>
        </a>
        <div class="info">
          <p class="info-item"><b>Likes</b> ${image.likes}</p>
          <p class="info-item"><b>Views</b> ${image.views}</p>
          <p class="info-item"><b>Comments</b> ${image.comments}</p>
          <p class="info-item"><b>Downloads</b> ${image.downloads}</p>
        </div>
        </li>`;
    }).join('');

    gallery.insertAdjacentHTML('beforeend', markup);

    lightbox.refresh();
}

export function clearGallery() {
    const gallery = document.querySelector(".gallery");
    gallery.innerHTML = "";
}

export function showLoader() {
    const loader = document.querySelector(".loader");
    if(loader) loader.classList.remove("is-hidden");
}

export function hideLoader() {
    const loader = document.querySelector(".loader");
    if(loader) loader.classList.add("is-hidden");
}

export function showLoadMoreButton() {
    const button = document.querySelector('.load-more');
    if(button) button.classList.remove('is-hidden'); 
}

export function hideLoadMoreButton() {
    const button = document.querySelector('.load-more');
    if(button) button.classList.add('is-hidden'); 
}